import BSpinnerInline from 'components/common/BSpinnerInline';
import Modal from 'components/common/Modal';
import DemandPagination from 'components/Demand/DemandPagination';
import VehicleDetailCommentsItem from 'components/Vehicle/VehicleDetail/VehicleDetailCommentsItem';
import { useFirstRender } from 'hooks/useFirstRender';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent, useState } from 'react';
import { experienceRatingService } from 'services/Experience/ExperienceRatingService';
import { useVehicleDetailCommentsModal } from 'states/useVehicleDetailCommentsModalState';
import { ExperienceRating } from 'types/experience/experience-rating.type';

interface ExperienceDetailCommentModalProps {
  experienceId: number;
}

const ExperienceDetailCommentModal: FunctionComponent<
  ExperienceDetailCommentModalProps
> = ({ experienceId }) => {
  const { t } = useTranslation('vehicle');
  const { isCommentModalVisible, setCommentModalVisible } =
    useVehicleDetailCommentsModal();
  const [loading, setLoading] = useState<boolean>(false);
  const [comments, setComments] = useState<ExperienceRating[]>([]);
  const [page, setPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);

  const getComments = async (page: number) => {
    try {
      setLoading(true);
      const res = await experienceRatingService.getExperienceRatings(
        experienceId,
        {
          size: 5,
          page,
        }
      );
      setComments(res.content);
      setPage(page);
      setTotalPages(res.totalPages);
    } finally {
      setLoading(false);
    }
  };

  useFirstRender(() => {
    getComments(0);
  });

  return (
    <Modal
      modalTitle={t('vehicle:commentModalTitle')}
      show={isCommentModalVisible}
      setShow={setCommentModalVisible}
    >
      {loading ? (
        <div className="flex h-full min-h-[70vh] w-full items-center justify-center">
          <BSpinnerInline />
        </div>
      ) : (
        <div className="flex h-full min-h-[70vh] flex-col justify-between">
          <div className="space-y-8">
            {comments.map((comment) => (
              <VehicleDetailCommentsItem
                comment={comment.content}
                // answer={null}
                commentDate={comment.commentDate}
                commentor={comment.commentor}
                title={comment.title}
                rating={comment.rateBundle.average}
                className="mb-6"
                key={comment.commentId}
              />
            ))}
          </div>
          <div className="mt-auto">
            <DemandPagination
              changePage={getComments}
              page={page}
              totalPages={totalPages}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ExperienceDetailCommentModal;
